/** Default display name for an offering (Vorgang) when title is empty. */
export const DEFAULT_OFFERING_TITLE = 'Vorgang';

/** Auto-generated offering title, e.g. „Vorgang 1“. */
export function defaultOfferingTitleForIndex(n: number): string {
  return `${DEFAULT_OFFERING_TITLE} ${n}`;
}

/** Legacy „Angebot N“ and current „Vorgang N“ titles from create/backfill. */
export const OFFERING_AUTO_TITLE_RE = /^(?:Angebot|Vorgang)\s*(\d+)\s*$/i;

export function parseOfferingAutoTitleIndex(title: string | null | undefined): number | null {
  const t = (title || '').trim();
  const m = OFFERING_AUTO_TITLE_RE.exec(t);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return Number.isFinite(n) ? n : null;
}
